import React from 'react';
import { Card, CardImg, CardBody, CardText, CardTitle, Button, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';
import { FadeTransform } from 'react-animation-components';

function RenderMonthlyNav({ item, isLoading, errMess }) {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <Card>
                <Link to={'/finance/monthly'} >
                    <FadeTransform in
                        transformProps={{
                            exitTransform: 'scale(0.5) translateY(-50%)'
                        }}>
                        <CardImg src={item.image} alt={item.name} />
                        <div className="card-link-color">
                            <CardBody>
                                <CardTitle>{item.name}</CardTitle>
                                <CardText>{item.description} <Button outline>Enter</Button></CardText>
                            </CardBody>
                        </div>
                    </FadeTransform>
                </Link>
            </Card>
        );
}

function RenderManagementNav({ item, isLoading, errMess }) {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMess) {
        return (
            <h4>{errMess}</h4>
        );
    }
    else
        return (
            <Card>
                <Link to={'/finance/management'} >
                    <FadeTransform in
                        transformProps={{
                            exitTransform: 'scale(0.5) translateY(-50%)'
                        }}>
                        <CardImg src={item.image} alt={item.name} />
                        <div className="card-link-color">
                            <CardBody>
                                <CardTitle>{item.name}</CardTitle>
                                <CardText>{item.description} <Button outline>Enter</Button></CardText>
                            </CardBody>
                        </div>
                    </FadeTransform>
                </Link>
            </Card>
        );
}

function Finance(props) {
    return (
        <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Finance</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>Finance</h3>
                    <hr />
                </div>
            </div>
            <div className="row align-items-start">
                <div className="col-12 col-md m-1">
                    <RenderMonthlyNav item={props.monthly}
                        isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                </div>
                <div className="col-12 col-md m-1">
                    <RenderManagementNav item={props.management}
                        isLoading={props.financesLoading}
                        errMess={props.financesErrMess} />
                </div>
            </div>
        </div>
    );
}

export default Finance;


// WEBPACK FOOTER //
// ./src/components/FinanceComponent.js